export const generateCrmCompaniesPayload = crmCompanies =>
  crmCompanies.reduce((acc, crmCompany) => {
    acc.push(
      ...crmCompany.companyIds.map(companyId => ({
        crmSourceId: +crmCompany.id,
        companyId,
      })),
    );

    return acc;
  }, []);

export const generateCrmCompaniesValues = (crmCompanies, crmSourcesList) =>
  Object.values(
    crmCompanies.reduce((acc, { crmSourceId, companyId }) => {
      if (!acc[crmSourceId]) {
        // eslint-disable-next-line no-param-reassign
        acc[crmSourceId] = {
          id: crmSourceId,
          companyIds: [],
          name: crmSourcesList.find(crmSource => crmSource.id === crmSourceId)
            ?.name,
        };
      }
      acc[crmSourceId].companyIds.push(+companyId);
      return acc;
    }, {}),
  ).sort((a, b) => a.name.localeCompare(b.name));

export default generateCrmCompaniesPayload;
